export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  REGULAR: 'regular',
}